import { render, staticRenderFns } from "./payType.vue?vue&type=template&id=10f2411e&scoped=true&"
import script from "./payType.vue?vue&type=script&lang=js&"
export * from "./payType.vue?vue&type=script&lang=js&"
import style0 from "./payType.vue?vue&type=style&index=0&id=10f2411e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f2411e",
  null
  
)

export default component.exports